const findObjectById = (id, objectToFind) => {
  return (
    Object.values(objectToFind).find(
      (item) => item.id.toString() === id.toString()
    ) || null
  );
};
export default findObjectById;
